import { EventSubscriber } from '@verdant-web/common';
export class BackoffScheduler extends EventSubscriber {
    constructor(backoff) {
        super();
        this.timer = null;
        this.isScheduled = false;
        this.next = () => {
            if (!this.isScheduled) {
                this.isScheduled = true;
                this.timer = setTimeout(() => {
                    this.emit('trigger');
                    this.isScheduled = false;
                    this.backoff.next();
                }, this.backoff.current);
            }
        };
        this.reset = () => {
            this.backoff.reset();
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        };
        this.backoff = backoff;
    }
}
export class Backoff {
    constructor(max, factor) {
        this.current = 0;
        this.next = () => {
            this.current = Math.min(this.max, this.current * this.factor);
        };
        this.reset = () => {
            this.current = 0;
        };
        this.max = max;
        this.factor = factor;
    }
}
//# sourceMappingURL=BackoffScheduler.js.map